module.exports = __webpack_public_path__ + "static/img/bbmlogo.7df3a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/bbmlogo.png
// module id = qF2c
// module chunks = 0